/**
 * EmailAuditoriaEnvio
 */
import {ID, Resource, ResponseSerialize, TAG} from 'simpli-web-sdk'
import EmailAuditoriaEnvioSchema from '@/schema/EmailAuditoriaEnvio.schema'
import Carga from '@/model/resource/Carga'
import EmailNivel from '@/model/resource/EmailNivel'
import AuditoriaMotivo from '@/model/resource/AuditoriaMotivo'
import Responsavel from '@/model/resource/Responsavel'

export default class EmailAuditoriaEnvio extends Resource {

  get $schema() {
    return EmailAuditoriaEnvioSchema(this)
  }

  get $id() {
    return this.idEmailAuditoriaEnvioPk
  }
  set $id(val: ID) {
    this.idEmailAuditoriaEnvioPk = val
  }

  get $tag() {
    return this.nomeGrupo
  }
  set $tag(val: TAG) {
    this.nomeGrupo = val
  }

  readonly $name: string = 'EmailAuditoriaEnvio'

  readonly $endpoint: string = '/user/email-auditoria-envio'

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  emailNivel: EmailNivel | null = null

  nomeGrupo: string = ''

  dataEnvio: Date | null = null

  auditoriaMotivo: AuditoriaMotivo | null = null

  idEmailAuditoriaEnvioPk: ID = 0

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(idCargaFk: ID) {
    if (!this.carga) this.carga = new Carga()
    this.carga.idCargaPk = idCargaFk
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.idResponsavelPk = idResponsavelFk
  }
}
